import { waitForIDs } from 'app/copied/getIds';
import { useEffect, useState } from 'react';

export default function useWebchatVersion() {
  const [webchatVersion, setWebchatVersion] = useState<string | null>(null);

  useEffect(() => {
    async function fetchWebchatVersion() {
      const { webchatVersion } = await waitForIDs();
      setWebchatVersion(webchatVersion);
    }
    fetchWebchatVersion();
  }, []);

  return webchatVersion;
}
